<template>
<section id="main-content">
  <section class="wrapper">
    <section class="login container-fluid">
    </section>
      <div class="container box-login">
          <div class="row">
          </div>
      </div>
  </section>
</section>
</template>

<script>
import UsuarioAPI from '@/api/usuario-api'
import LoginUtils from '@/core/util/login-utils'
import EmpresaUtils from '@/core/util/empresa-utils'
import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'LoginPorTokenView',

  data () {
    return {
      submitLogin: false,
      erroLogin: null,
      token: null,
      empresaId: null,
      empresas: [],
      empresa: null
    }
  },

  created () {
  },

  mounted () {
    this.token = this.$route.params.token
    this.empresaId = parseInt(this.$route.query.empresaId)
    this.loginPorToken()
  },

  methods: {
    loginPorToken: async function () {
      this.erroLogin = null
      this.submitLogin = true

      try {
        const dataValidarAcesso = await UsuarioAPI.validarAcesso(this.token, this.empresaId)
        LoginUtils.setToken(dataValidarAcesso.access_token)

        const dataObterusuario = await UsuarioAPI.obterUsuario()
        const usuario = dataObterusuario.user

        if (usuario) {
          LoginUtils.setUsuario(usuario)
          this.empresas = EmpresaUtils.limitaEmpresas(usuario)

          this.empresas.map(empresa => {
            if (empresa.id === this.empresaId) {
              this.empresa = empresa
            }
          })

          EmpresaUtils.setEmpresa(this.empresa)

          window.location = this.$route.query.redir ? this.$route.query.redir : '/home'
        }
      } catch (e) {
        this.showLoginError(e)
      }
    },

    showLoginError: function (e) {
      this.submitLogin = false

      const errorData = ResponseUtils.getErrorData(e)
      if (errorData && errorData.error === 'too_many_attempts') {
        this.erroLogin = errorData.error_description
      } else {
        this.erroLogin = 'Email e/ou senha inválida.'
      }

      LoginUtils.logout()
    }
  }
}
</script>
